import React, { useState } from "react";
import DataTable from "react-data-table-component";
import ExecutionDetails from "../ExecutionDetails";
import { data as newData } from "./../newData";
import { Tooltip, Typography, Grid } from "@material-ui/core";
import styled from "styled-components";

const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      cursor: "pointer",
      fontSize: 16,
      minHeight: "unset"
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
      justifyContent: "center",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "center",
    },
  },
};

const StyledDataTable = styled(DataTable)`
  .rdt_TableBody {
    overflow: auto;
    max-height: calc(100vh - 425px)
  }
`;

const columns = [
  {
    name: "Test Execution ID",
    selector: "Test_case_execution_id",
  },
  {
    name: "Model",
    selector: "Model",
  },
  {
    name: "Execution",
    selector: "Execution",
  },
  {
    name: "Status",
    selector: "Status",
  },
  {
    name: "Scenario Count",
    selector: "Total_Scenarios_Executed",
    cell: (row) => {
      return (
        <>
          <Tooltip
            title={Object.values(row.Scenarios_Executed).map((scenarioKey) => {
              return (
                <div style={{ fontSize: "14px", marginTop: "5px" }}>
                  {scenarioKey}
                </div>
              );
            })}
            placement="right"
          >
            <span>{row.Total_Scenarios_Executed}</span>
          </Tooltip>
        </>
      );
    },
  },

  {
    name: "Executed By",
    selector: "Executed_by",
  },
  {
    name: "Started At",
    selector: "StartedAt",
  },
  {
    name: "Completed At",
    selector: "CompletedAt",
  },
  {
    name: "Action",
    selector: "",
  },
];

let finalData = [];
console.log(newData);
Object.keys(newData).map((multipleData) => {
  console.log(multipleData);
  finalData.push(newData[multipleData].test_execution_history);
});

console.log("data new", finalData);

const ExecutionList = () => {
  const [selectedExecution, setSelectedExecution] = useState(true);

  const handleRowClick = (row) => {
    console.log("CLICKED", row);
    setSelectedExecution(row);
  };
  if (selectedExecution) {
    return (
      <ExecutionDetails
        selectedExecution={selectedExecution}
        onBack={() => setSelectedExecution(null)}
      ></ExecutionDetails>
    );
  }
  return (
    <div style={{ padding: "20px" }}>
      <Grid
        container
        style={{
          marginTop: "30px",
          backgroundColor: "white",
          padding: "1%",
          border: "solid 1px rgba(0,0,0,.2)",
          borderRadius: "10px",
        }}
      >
        <Typography variant="h5" style={{ marginBottom: "10px" }}>
          Cloud Executions
        </Typography>
        <StyledDataTable
          columns={columns}
          data={finalData}
          customStyles={customStyles}
          onRowClicked={handleRowClick}
          highlightOnHover
        ></StyledDataTable>
      </Grid>
    </div>
  );
};

export default ExecutionList;
